export enum RptGenerateRecordStatusEnum {
  DOING = 'DOING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  EXCEPTION = 'EXCEPTION'
}
